import ModalRdv from '@pages/offer-page/calendly/ModalRdv.vue';
import { URL_USER_SETTINGS_ONBOARDING_MATCH_RDV } from '@tools/routes/routes';
import { createApp } from 'vue';
import { userSettingMixin } from '@pages/offer-page/calendly/user-setting';

/**
 * Init RDV Modal Vue
 */
export const calendly = () => {
  if (document.querySelector('.rdv') === null) {
    return;
  }

  const component = {
    components: {
      ModalRdv,
    },
    mixins: [ userSettingMixin ],
    data() {
      return {
        isRDVModalOpened: false,
      };
    },
    mounted() {
      this.showRDVModal();
    },
    methods: {
      showRDVModal: function showRDVModal() {
        this.isRDVModalOpened = true;
      },
      closeRDVModal: function closeRDVModal() {
        this.isRDVModalOpened = false;
        this.enableUserSetting(URL_USER_SETTINGS_ONBOARDING_MATCH_RDV);
      },
    },
  };

  createApp(component).mount('.rdv');
};
